// ADM-1009 prototype — throwaway mock fixture for the Card Ordering Audit page.
// Shape mirrors the Phase 2 smoke-test output of card_ordering_audit_prototype.sql,
// with a hand-curated distribution that exercises every pipeline_status value and
// a realistic ~15% SLA-breach rate. Not for merge.

const TENANT_NAMES = {
  'ten-353ae621abde4e22be409325a1dd0eab': 'Acme Health Plan',
  'ten-9ca77b65a8fe43d3a18b9e1c20df0e5b': 'Bayside Medicare Advantage',
  'ten-7f2cc1d65b294f1b96d80a4f7c531b1c': 'Cascade Wellness',
};

export const TENANT_OPTIONS = Object.entries(TENANT_NAMES).map(([code, name]) => ({
  code,
  name,
}));

export function tenantNameFor(code) {
  return TENANT_NAMES[code] || code;
}

// Hand-crafted card-level rows. Dates are within the 2026-05-04 to 2026-05-15
// window used in the Phase 2 smoke test.
export const MOCK_CARD_ROWS = [
  // --- COMPLETED, within SLA (12 rows) ---
  row('4246081655353', 'cmr-fdaca51e49154529871dd534b0e62ca7', 'ten-353ae621abde4e22be409325a1dd0eab', 'BARBARA',  'SHELLENBERGER', '2026-05-04', '2026-05-05', '2026-05-06', '2026-05-08'),
  row('4246082113447', 'cmr-7f1b920c331a4f47b7e16baca18a2eb1', 'ten-353ae621abde4e22be409325a1dd0eab', 'WILLIAM',  'LANNIN',        '2026-05-04', '2026-05-05', '2026-05-06', '2026-05-08'),
  row('4246085524012', 'cmr-22f0c47e7d7e472eb9a9e4b0fa54a8e1', 'ten-9ca77b65a8fe43d3a18b9e1c20df0e5b', 'JAMES',    'OKONKWO',       '2026-05-04', '2026-05-05', '2026-05-06', '2026-05-07'),
  row('4246086701988', 'cmr-cf28b91e8aa54b9d8f1c2e5f4d9a6f31', 'ten-9ca77b65a8fe43d3a18b9e1c20df0e5b', 'MARIA',    'GUTIERREZ',     '2026-05-05', '2026-05-06', '2026-05-07', '2026-05-08'),
  row('4246087829441', 'cmr-1a8e2bcd64fa48198d2afb6c193f88a2', 'ten-7f2cc1d65b294f1b96d80a4f7c531b1c', 'SAMUEL',   'CHEN',          '2026-05-05', '2026-05-06', '2026-05-07', '2026-05-09'),
  row('4246088935002', 'cmr-3b91c4dd5e0c4f228d8f7b1ce3a40193', 'ten-353ae621abde4e22be409325a1dd0eab', 'ELIZABETH','PARK',          '2026-05-06', '2026-05-07', '2026-05-08', '2026-05-09'),
  row('4246090147881', 'cmr-9c4d8a7e2b1f4a5c9e8d3f6b2a14d72e', 'ten-353ae621abde4e22be409325a1dd0eab', 'ROBERT',   'NGUYEN',        '2026-05-06', '2026-05-07', '2026-05-08', '2026-05-10'),
  row('4246091254008', 'cmr-7e2f9d8c5a3b48f1ad8e6c3a9b50d471', 'ten-9ca77b65a8fe43d3a18b9e1c20df0e5b', 'PATRICIA', 'ANDERSEN',      '2026-05-07', '2026-05-08', '2026-05-09', '2026-05-11'),
  row('4246092361113', 'cmr-4a8d2f6b9c1e457f8d3a5b9c2e7d8a01', 'ten-7f2cc1d65b294f1b96d80a4f7c531b1c', 'DAVID',    'OBI',           '2026-05-07', '2026-05-08', '2026-05-09', '2026-05-12'),
  row('4246093478256', 'cmr-1f7c9d2e3b8a4c5d6e7f8a9b0c1d2e3f', 'ten-353ae621abde4e22be409325a1dd0eab', 'JENNIFER', 'SVENSSON',      '2026-05-08', '2026-05-09', '2026-05-10', '2026-05-12'),
  row('4246094589333', 'cmr-8b3c9d4e5f6a7b1c2d3e4f5a6b7c8d9e', 'ten-7f2cc1d65b294f1b96d80a4f7c531b1c', 'MICHAEL',  'KOWALCZYK',     '2026-05-08', '2026-05-09', '2026-05-10', '2026-05-12'),
  row('4246095692047', 'cmr-2e7f8a1b3c4d5e6f7a8b9c0d1e2f3a4b', 'ten-9ca77b65a8fe43d3a18b9e1c20df0e5b', 'LINDA',    'TRAN',          '2026-05-09', '2026-05-10', '2026-05-11', '2026-05-13'),

  // --- COMPLETED, but SLA-BREACHED (5 rows, ~15% of completed) ---
  row('4246081155221', 'cmr-bd91f4a82c3d4e5f6a7b8c9d0e1f2a3b', 'ten-353ae621abde4e22be409325a1dd0eab', 'CHARLES',  'JOHANSEN',      '2026-05-04', '2026-05-05', '2026-05-07', '2026-05-12'),
  row('4246081955302', 'cmr-c4d5e6f7a8b9c0d1e2f3a4b5c6d7e8f9', 'ten-9ca77b65a8fe43d3a18b9e1c20df0e5b', 'KAREN',    'OLIVEIRA',      '2026-05-04', '2026-05-06', '2026-05-08', '2026-05-12'),
  row('4246082855491', 'cmr-d5e6f7a8b9c0d1e2f3a4b5c6d7e8f9a0', 'ten-353ae621abde4e22be409325a1dd0eab', 'BRIAN',    'YAMAMOTO',      '2026-05-05', '2026-05-06', '2026-05-08', '2026-05-13'),
  row('4246083721004', 'cmr-e6f7a8b9c0d1e2f3a4b5c6d7e8f9a0b1', 'ten-7f2cc1d65b294f1b96d80a4f7c531b1c', 'STEPHANIE','DELACRUZ',      '2026-05-06', '2026-05-07', '2026-05-09', '2026-05-14'),
  row('4246084829112', 'cmr-f7a8b9c0d1e2f3a4b5c6d7e8f9a0b1c2', 'ten-9ca77b65a8fe43d3a18b9e1c20df0e5b', 'GREGORY',  'MWANGI',        '2026-05-07', '2026-05-08', '2026-05-10', '2026-05-15'),

  // --- STUCK at callback (FIS returned proxy but AB never received / shipped) ---
  row('4246086002311', 'cmr-a8b9c0d1e2f3a4b5c6d7e8f9a0b1c2d3', 'ten-353ae621abde4e22be409325a1dd0eab', 'DOROTHY',  'PETROV',        '2026-05-12', '2026-05-13', null, null),
  row('4246086115887', 'cmr-b9c0d1e2f3a4b5c6d7e8f9a0b1c2d3e4', 'ten-9ca77b65a8fe43d3a18b9e1c20df0e5b', 'THOMAS',   'IBRAHIMOV',     '2026-05-12', '2026-05-13', null, null),
  row('4246086294003', 'cmr-c0d1e2f3a4b5c6d7e8f9a0b1c2d3e4f5', 'ten-7f2cc1d65b294f1b96d80a4f7c531b1c', 'CYNTHIA',  'O\u2019BRIEN',   '2026-05-13', '2026-05-14', null, null),

  // --- STUCK at intake (would be AB intake confirmed but not shipped — but intake_date is from stub stays null; pipeline_status fallback is stuck_at_intake when intake is populated). For UI realism we simulate one where intake came in but shipping is missing. ---
  row('4246087401556', 'cmr-d1e2f3a4b5c6d7e8f9a0b1c2d3e4f5a6', 'ten-353ae621abde4e22be409325a1dd0eab', 'KEVIN',    'ABRAMOWICZ',    '2026-05-11', '2026-05-12', '2026-05-13', null),

  // --- STUCK at send (no FIS callback received) ---
  row('4246088502991', 'cmr-e2f3a4b5c6d7e8f9a0b1c2d3e4f5a6b7', 'ten-9ca77b65a8fe43d3a18b9e1c20df0e5b', 'ANGELA',   'ROSSELLINI',    '2026-05-14', null, null, null),
  row('4246088620114', 'cmr-f3a4b5c6d7e8f9a0b1c2d3e4f5a6b7c8', 'ten-353ae621abde4e22be409325a1dd0eab', 'JONATHAN', 'BANERJEE',      '2026-05-15', null, null, null),

  // --- NOT STARTED (proxy exists from prior history, no recent send) ---
  row('4246090001772', 'cmr-04b5c6d7e8f9a0b1c2d3e4f5a6b7c8d9', 'ten-7f2cc1d65b294f1b96d80a4f7c531b1c', 'AMANDA',   'KOWALSKI',      null, null, null, null),
];

// Row builder — computes derived fields (days, SLA breach flags, pipeline_status)
// in the same way the prototype SQL does, so the UI shows realistic values.
function row(proxy, consumerCode, tenantCode, firstName, lastName, sent, callback, intake, shipped) {
  const days_send_to_callback   = diffDays(sent, callback);
  const days_callback_to_ship   = diffDays(callback, shipped);
  const days_send_to_ship       = diffDays(sent, shipped);
  const sla_breach_send_to_callback = sent && callback && days_send_to_callback > 1;
  const sla_breach_total_5_days     = sent && shipped && days_send_to_ship > 5;

  let pipeline_status;
  if (!sent)                  pipeline_status = 'not_started';
  else if (shipped)           pipeline_status = 'completed';
  else if (!callback)         pipeline_status = 'stuck_at_send';
  else if (!intake)           pipeline_status = 'stuck_at_callback';
  else                        pipeline_status = 'stuck_at_intake';

  return {
    card_number_proxy: proxy,
    consumer_code: consumerCode,
    tenant_code: tenantCode,
    first_name: firstName,
    last_name: lastName,
    sent_to_fis_date: sent,
    fis_callback_date: callback,
    ab_intake_date: intake,
    ab_shipped_date: shipped,
    days_send_to_callback,
    days_callback_to_ship,
    days_send_to_ship,
    sla_breach_send_to_callback: !!sla_breach_send_to_callback,
    sla_breach_total_5_days: !!sla_breach_total_5_days,
    pipeline_status,
  };
}

function diffDays(a, b) {
  if (!a || !b) return null;
  const ms = new Date(b).getTime() - new Date(a).getTime();
  return Math.round(ms / 86400000);
}

// Rolls the card rows up to the (date, tenant) grain that the file/date summary
// view consumes. Anchor date is sent_to_fis_date; intake_count is always 0 since
// the AB intake stub does not populate. Used by the prototype page.
export function buildSummaryRows(cardRows) {
  const grouped = {};
  for (const r of cardRows) {
    if (!r.sent_to_fis_date) continue;
    const key = `${r.sent_to_fis_date}|${r.tenant_code}`;
    if (!grouped[key]) {
      grouped[key] = {
        date: r.sent_to_fis_date,
        tenant_code: r.tenant_code,
        tenant_name: tenantNameFor(r.tenant_code),
        sent_count: 0,
        callback_count: 0,
        intake_count: 0,
        shipped_count: 0,
        breached_count: 0,
      };
    }
    const g = grouped[key];
    g.sent_count     += 1;
    if (r.fis_callback_date) g.callback_count += 1;
    if (r.ab_intake_date)    g.intake_count   += 1;
    if (r.ab_shipped_date)   g.shipped_count  += 1;
    if (r.sla_breach_total_5_days) g.breached_count += 1;
  }
  return Object.values(grouped)
    .map((g) => ({
      ...g,
      delta_send_to_callback: g.sent_count - g.callback_count,
      delta_callback_to_ship: g.callback_count - g.shipped_count,
    }))
    .sort((a, b) => (a.date < b.date ? 1 : a.date > b.date ? -1 : a.tenant_name.localeCompare(b.tenant_name)));
}
